import vivekPhoto from '../../../img/renaissance-new/industryExperts/Vivek.webp';
import anoopPhoto from '../../../img/renaissance-new/industryExperts/Anoop.webp';
import likhileshPhoto from '../../../img/renaissance-new/industryExperts/Likhilesh.webp';
import birenPhoto from '../../../img/renaissance-new/industryExperts/Biren.webp';
import javedPhoto from '../../../img/renaissance-new/industryExperts/Javed.webp';
import kshitizPhoto from '../../../img/renaissance-new/industryExperts/Kshitiz.webp';
import deepakPhoto from '../../../img/renaissance-new/industryExperts/Deepak.webp';
import swapnilPhoto from '../../../img/renaissance-new/industryExperts/Swapnil.webp';
import harshPhoto from '../../../img/renaissance-new/industryExperts/Harsh.webp';

export const MENTORS_ROW_1 = [
  { name: "Vivekanand Vivek", title:"Co-Founder |\nIIT BHU", photo: vivekPhoto },
  { name: "Anoop Garg", title:"Co-Founder |\nIIT BHU", photo: anoopPhoto },
  { name: "Likhilesh Balpande", title:"Technical Lead |\nIIT Dharwad", photo: likhileshPhoto },
  { name: "Javed Alam Khan", title:"IIIT Hyderabad |\nEx - Make My Trip", photo: javedPhoto },
  { name: "Kshitiz Verma", title:"IIT Kanpur |\nMS+PHD UCSM Madrid", photo: kshitizPhoto },
];

export const MENTORS_ROW_2 = [
  { name: "Deepak Gupta", title:"NIT Kurukshetra |\nFounding Engineer DevRev", photo: deepakPhoto },
  { name: "Swapnil Pandey", title:"CM @ Codeforces | Ex - PanScience", photo: swapnilPhoto },
  { name: "Biren Goyal", title:"NIT Kurukshetra | Atlassian", photo: birenPhoto },
  { name: "Harsh Gugale", title:"IIT BHU | GPU Architect @ AMD", photo: harshPhoto },
];
